import React from "react";
import classes from "./HistoryBox.module.css";
import emojy10 from "../../assets/images/emojy/emojy10.png";
import emojy12 from "../../assets/images/emojy/emojy12.png";
const HistoryBox = () => {
  return (
    <div className={classes["history-box"]}>
      <div
        className={`${classes["history-img-box"]} ${classes["history-img-box01"]}`}
      >
        <img src={emojy10} />
      </div>
      <div
        className={`${classes["history-img-box"]} ${classes["history-img-box02"]}`}
      >
        <img src={emojy12} />
      </div>

      <ul className={classes["history"]}>
        <li className={classes["left"]}>
          <div>
            <div className={classes["bg-white"]}>
              <h4>2024.07</h4>
              <p>정보처리기사(한국산업인력공단)</p>
            </div>
          </div>
        </li>
        <li className={classes["right"]}>
          <div>
            <div className={classes["bg-white"]}>
              <h4>2021.03 ~ 2024.06</h4>
              <p>
                NCL - 부설연구소 개발팀
                <br />
                SPRING을 이용한 웹 개발 담당
              </p>
            </div>
          </div>
        </li>

        <li className={classes["left"]}>
          <div>
            <div className={classes["bg-white"]}>
              <h4>2020.09 ~ 2021.02</h4>
              <p>
                풀스택개발자양성과정(하이미디어아카데미인개발원)
                <br />
                JAVA 언어의 기초 및 웹 개발에 필요한 프로그래밍 기술 학습
              </p>
            </div>
          </div>
        </li>

        <li className={classes["right"]}>
          <div>
            <div className={classes["bg-white"]}>
              <h4>2020.08</h4>
              <p>컴퓨터활용능력 1급(대한상공회의소)</p>
            </div>
          </div>
        </li>

        <li className={classes["left"]}>
          <div>
            <div className={classes["bg-white"]}>
              <h4>2020.05</h4>
              <p>네트워크관리사 2급(한국정보통신자격협회)</p>
            </div>
          </div>
        </li>

        <li className={classes["right"]}>
          <div>
            <div className={classes["bg-white"]}>
              <h4>2019.03 ~ 2019.12</h4>
              <p>
                서울시 뉴딜일자리 스마트도시 분야 인턴
                <br />
                HTM, CSS, JQUERY를 이용하 웹 퍼블리싱 담당
              </p>
            </div>
          </div>
        </li>
        <li className={classes["left"]}>
          <div>
            <div className={classes["bg-white"]}>
              <h4>2012.02</h4>
              <p>상암고등하교졸업</p>
            </div>
          </div>
        </li>
      </ul>
    </div>
  );
};

export default HistoryBox;
